import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';

import { MAX_WIDTHS } from 'src/utils/constants';

import CustomTooltip from './CustomTooltip';

const AudioFileNameCell: React.FC<{ audioFileName: string }> = ({ audioFileName }) => (
  <TableCell>
    <CustomTooltip title={audioFileName}>
      <Box
        sx={{
          maxWidth: MAX_WIDTHS.COMPLIANCE_TABLE_CELL_FILE_NAME,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {audioFileName}
      </Box>
    </CustomTooltip>
  </TableCell>
);

export default AudioFileNameCell;
